import { render } from "./Bubble.vue?vue&type=template&id=2d4adbf3"
import script from "./Bubble.vue?vue&type=script&lang=js"
export * from "./Bubble.vue?vue&type=script&lang=js"

import "./Bubble.vue?vue&type=style&index=0&id=2d4adbf3&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__